import ActivityPagination from "components/ActivityLog/ActivityPagination.component";
import StoriesSkeletonRow from "components/Loader/Skeleton/storiesCard.skeleton";
import React from "react";
import { STORIES } from "../../../constants/images";
import StoryCard from "./story_card";

export default function StoriesContainer({
  setAddStoryModal,
  storiesList,
  isOwner,
  setDeleteStoryModal,
  storiesPaginationStates,
  setDeletingStoryID,
  storyPrevPage,
  storyNextPage,
  storiesSortByOptions,
  storiesSortByActive,
  SetStoriesSortByActive,
  isLoading,
}) {

  return (
    <div className="storiesCardContainer">
      <div className="sc-top-cta">
        <div className="filter-container">
          <div className="filter-text">Sort by</div>
          <div
            className="al-filters dropdown-toggle"
            data-bs-toggle="dropdown"
            aria-expanded="false"
          >
            {
              <svg
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M6 8C6 7.73478 6.10536 7.48043 6.29289 7.29289C6.48043 7.10536 6.73478 7 7 7H17C17.2652 7 17.5196 7.10536 17.7071 7.29289C17.8946 7.48043 18 7.73478 18 8C18 8.26522 17.8946 8.51957 17.7071 8.70711C17.5196 8.89464 17.2652 9 17 9H7C6.73478 9 6.48043 8.89464 6.29289 8.70711C6.10536 8.51957 6 8.26522 6 8Z"
                  fill="var(--black)"
                />
                <path
                  d="M8 12C8 11.7348 8.10536 11.4804 8.29289 11.2929C8.48043 11.1054 8.73478 11 9 11H15C15.2652 11 15.5196 11.1054 15.7071 11.2929C15.8946 11.4804 16 11.7348 16 12C16 12.2652 15.8946 12.5196 15.7071 12.7071C15.5196 12.8946 15.2652 13 15 13H9C8.73478 13 8.48043 12.8946 8.29289 12.7071C8.10536 12.5196 8 12.2652 8 12Z"
                  fill="var(--black)"
                />
                <path
                  d="M11 15C10.7348 15 10.4804 15.1054 10.2929 15.2929C10.1054 15.4804 10 15.7348 10 16C10 16.2652 10.1054 16.5196 10.2929 16.7071C10.4804 16.8946 10.7348 17 11 17H13C13.2652 17 13.5196 16.8946 13.7071 16.7071C13.8946 16.5196 14 16.2652 14 16C14 15.7348 13.8946 15.4804 13.7071 15.2929C13.5196 15.1054 13.2652 15 13 15H11Z"
                  fill="var(--black)"
                />
              </svg>
            }
            <div className="al-filter-selected ">
              {storiesSortByActive?.key}
            </div>
          </div>

          <ul className="dropdown-menu p-3" aria-labelledby="sortby">
            <li className="mb-1">
              {storiesSortByOptions?.map(({ key, value }, index) => (
                <button
                  className="dropdown-item"
                  key={index}
                  onClick={() => {
                    SetStoriesSortByActive({
                      key: key,
                      value: value,
                    });
                  }}
                >
                  {key}
                </button>
              ))}
            </li>
          </ul>
        </div>
        {isOwner ? (
          <button
            className="dark py-2 px-4"
            onClick={() => {
              setAddStoryModal(true);
            }}
          >
            <img src={STORIES.ADD} />
            Add new story
          </button>
        ) : null}
      </div>
      {isLoading
        ? [...Array(20)].map((elementInArray, index) => <StoriesSkeletonRow />)
        : storiesList.map(
          (
            {
              content,
              createdDate,
              writer,
              txHash,
              id,
              ownerDisabled,
              communityDisabled,
            },
            index
          ) => {
            if (
              ownerDisabled == "0x0" &&
              communityDisabled == "0x0"
            ) {
              return (
                <StoryCard
                  key={index}
                  content={content}
                  createdDate={createdDate}
                  is_owner_disabled={ownerDisabled}
                  is_community_disabled={communityDisabled}
                  setDeletingStoryID={setDeletingStoryID}
                  storyId={id}
                  setDeleteStoryModal={setDeleteStoryModal}
                  txHash={txHash}
                  writer={writer}
                  isOwner={isOwner}
                />
              );
            }
          }
        )}
      {!storiesPaginationStates.totalPages ? null : isLoading ? null : (
        <div className="storiesCardPaginationContainer">
          <div className="storiesCardPagination">
            <div
              className={`al-pagination-button left ${storiesPaginationStates.currentPage <= 1 ? "" : `active`
                }`}
              onClick={storyPrevPage}
            >
              {
                <svg
                  width="23"
                  height="16"
                  viewBox="0 0 23 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.5566 8.70711C22.9471 8.31658 22.9471 7.68342 22.5566 7.29289L16.1926 0.928932C15.8021 0.538408 15.1689 0.538408 14.7784 0.928932C14.3879 1.31946 14.3879 1.95262 14.7784 2.34315L20.4353 8L14.7784 13.6569C14.3879 14.0474 14.3879 14.6805 14.7784 15.0711C15.1689 15.4616 15.8021 15.4616 16.1926 15.0711L22.5566 8.70711ZM0.151367 9H21.8495V7H0.151367V9Z"
                    fill={
                      storiesPaginationStates.currentPage <= 1
                        ? "#0683854e"
                        : `#068385`
                    }
                  />
                </svg>
              }
            </div>
            <div className="al-text"> Page </div>
            <div className="al-input">
              <input
                type="text"
                id="pageNumber"
                placeholder={storiesPaginationStates.currentPage}
              />
            </div>
            <div className="al-text">
              {" "}
              of {storiesPaginationStates.totalPages}{" "}
            </div>
            <div
              className={`al-pagination-button right ${storiesPaginationStates.currentPage >=
                storiesPaginationStates.totalPages
                ? ""
                : `active`
                } `}
              onClick={storyNextPage}
            >
              {
                <svg
                  width="23"
                  height="16"
                  viewBox="0 0 23 16"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    d="M22.5566 8.70711C22.9471 8.31658 22.9471 7.68342 22.5566 7.29289L16.1926 0.928932C15.8021 0.538408 15.1689 0.538408 14.7784 0.928932C14.3879 1.31946 14.3879 1.95262 14.7784 2.34315L20.4353 8L14.7784 13.6569C14.3879 14.0474 14.3879 14.6805 14.7784 15.0711C15.1689 15.4616 15.8021 15.4616 16.1926 15.0711L22.5566 8.70711ZM0.151367 9H21.8495V7H0.151367V9Z"
                    fill={
                      storiesPaginationStates.currentPage >=
                        storiesPaginationStates.totalPages
                        ? "#0683854e"
                        : `#068385`
                    }
                  />
                </svg>
              }
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
